import * as service from './service'
import { HTTP_CODE } from '@/utils/request'
import { getDetailInfoData } from './service'

export default {
  namespace: 'serviceScoreDetail',
  state: {
    demoData: {}
  },
  effects: {
    * getDetailInfoData ({ payload }, { call, put }) {
      const res = yield call(service.getDetailInfoData, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
